import React from 'react';

import './Tag.scss';

export type TagProps = {
    label: string;
    status?: 'active' | 'inactive' | 'primary';
};

const Tag = ({ label, status }: TagProps) => {
    let statusElement;

    if (status) {
        statusElement = (
            <div className={`yat-card-tag__status yat-card-tag__status--${status}`}>
                <div />
            </div>
        );
    }

    return (
        <div className="yat-card-tag">
            {statusElement}
            <div className="yat-card-tag__label">{label}</div>
        </div>
    );
};

export default Tag;
